import { TableCell, TableRow } from "@mui/material";
import { GroupKey, JBoxTypeKey, RampTestKey } from "../types";
import { FieldConfig } from "../constants/tableConfig";
import CustomNumberInput from "./CustomNumberInput";

interface PlanningDataRowsProps {
  fields: FieldConfig[];
  groupKey: GroupKey;
  rampTestKey: RampTestKey;
  existingJboxTypes: JBoxTypeKey[];
  isSoc: boolean;
  socActive?: boolean;
  afrrActive: boolean;
}

const PlanningDataRows = ({
  fields,
  groupKey,
  rampTestKey,
  existingJboxTypes,
  isSoc,
  socActive,
  afrrActive,
}: PlanningDataRowsProps) => {
  return (
    <>
      {fields.map(({ key: fieldKey, label, singleField, helperText }) => {
        const disabled = isSoc ? !socActive : !afrrActive;
        return (
          <TableRow key={fieldKey}>
            <TableCell size="small" sx={{ fontSize: "1.1rem" }}>
              {label}
            </TableCell>
            {singleField ? (
              <TableCell size="small" colSpan={existingJboxTypes.length}>
                <CustomNumberInput
                  source={`${rampTestKey}.${groupKey}.${fieldKey}`}
                  disabled={disabled}
                  helperText={helperText}
                />
              </TableCell>
            ) : (
              existingJboxTypes.map((jbox) => (
                <TableCell key={jbox} size="small">
                  <CustomNumberInput
                    source={`${rampTestKey}.${groupKey}.${fieldKey}.${jbox}`}
                    disabled={disabled}
                    helperText={helperText}
                  />
                </TableCell>
              ))
            )}
            <TableCell />
          </TableRow>
        );
      })}
    </>
  );
};

export default PlanningDataRows;
